import { Fragment, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import Navbar from './RoundToJoin/navbar';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import LockIcon from "../Asserts/images/Lock.svg"
import EditIcon from "../Asserts/images/edit.svg"
import axios from 'axios';
import { baseURL } from '../services/axiosConfig';
import { refreshTokenV2 } from '../services/api';
import { countries as countryData } from "countries-list";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import PhoneInput from 'react-phone-input-2';
import { parsePhoneNumberFromString } from "libphonenumber-js";
import useDeviceType from '../Utiles/FindDevice';
import { NATIONALITY } from './Auth/nationality';
import useToastMessage from '../Utiles/Toaster';
import { Toaster } from 'react-hot-toast';
import CryptoJS from 'crypto-js';
import Footer from '../Components/Footer';

const countryOptions = Object.values(countryData).map((country) => ({
  label: country.name,
  value: country.name,
}));

const REQUIRED_FIELDS = ["address_line_1", "city", "state", "country", "nationality", "date_of_birth"];

const MyProfile = () => {
  const [selectedNav, setSelectedNav] = useState("");
  const [dropdownMenuOpen, setDropdownMenuOpen] = useState(false);
  const [otherMenusOpen, setOtherMenusOpen] = useState(false);
  const [dropdownPos, setDropdownPos] = useState({});
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const token = localStorage.getItem("access_token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo")) || {};
  const deviceType = useDeviceType();
  const { showSuccessToast, showErrorToast } = useToastMessage();
  const [bankData, setBankData] = useState([]);
  var derived_key = process.env.REACT_APP_ENCRYPTION_KEY ? CryptoJS.enc.Base64.parse(process.env.REACT_APP_ENCRYPTION_KEY) : null;
  var iv = process.env.REACT_APP_IV ? CryptoJS.enc.Utf8.parse(process.env.REACT_APP_IV) : null;


  const [userData, setUserData] = useState({});
  const [originalUserData, setOriginalUserData] = useState({});
  const [termsAccepted, setTermsAccepted] = useState(false);


  const [isEditingProfile, setIsEditingProfile] = useState(false);
  const [isEditingGames, setIsEditingGames] = useState(false);
  const [isEditingLeagues, setIsEditingLeagues] = useState(false);
  const [preferredGames, setPreferredGames] = useState([]);
  const [preferredLeagues, setPreferredLeagues] = useState([]);
  const [optionalConsent, setOptionalConsent] = useState(false);
  const [isEmailConsent, setIsEmailConsent] = useState(false);
  const [isPhoneConsent, setIsPhoneConsent] = useState(false);
  const [isWhatsappConsent, setIsWhatsappConsent] = useState(false);
  const [isSmsConsent, setIsSmsConsent] = useState(false);
  const [platformNotifications, setPlatformNotifications] = useState(false);
  const [marketingEmails, setMarketingEmails] = useState(false);
  const [originalConsentStates, setOriginalConsentStates] = useState({
    optionalConsent: false,
    isEmailConsent: false,
    isPhoneConsent: false,
    isWhatsappConsent: false,
    isSmsConsent: false,
    platformNotifications: false,
    marketingEmails: false,
  });


  const handleTermsChange = (e) => {
    setTermsAccepted(e.target.checked);
  };
  const handleOptionalConsentChange = (e) => {
    const checked = e.target.checked;
    setOptionalConsent(checked);
    
    if (!checked) {
      setIsEmailConsent(false);
      setIsPhoneConsent(false);
      setIsSmsConsent(false);
      setPlatformNotifications(false);
      setMarketingEmails(false);
    } else {
      setIsEmailConsent(true);
      setIsPhoneConsent(true);
      setIsSmsConsent(true);
      setPlatformNotifications(true);
      setMarketingEmails(true);
    }
  };
  const handleEmailConsentChange = (e) => {
    const checked = e.target.checked;
    setIsEmailConsent(checked);
    
    if (!checked) {
      setPlatformNotifications(false);
      setMarketingEmails(false);
    } else {
      setPlatformNotifications(true);
      setMarketingEmails(true);
    }
  };
  const handlePlatformNotificationsChange = (e) => {
    const checked = e.target.checked;
    setPlatformNotifications(checked);
    if (!checked && !marketingEmails) {
      setIsEmailConsent(false);
    }
  };
  const handleMarketingEmailsChange = (e) => {
    const checked = e.target.checked;
    setMarketingEmails(checked);
    if (!checked && !platformNotifications) {
      setIsEmailConsent(false);
    }
  };



  const transferTypeOptions = {
    'BBAN': 'BBAN - Beneficiary Bank Account Number',
    'IBAN': 'IBAN - International Bank Account Number',
  };

  const decryptAccountDetails = (encryptedData) => {
    if (!derived_key || !iv) return encryptedData;
    const decrypted_initial = CryptoJS.AES.decrypt(encryptedData, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    const decrypted = CryptoJS.AES.decrypt(decrypted_initial, derived_key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
    }).toString(CryptoJS.enc.Utf8);

    return decrypted;
  }

  // Custom DatePicker styles
  const datePickerStyles = `
    .react-datepicker-wrapper {
      width: 100%;
    }
    .react-datepicker__input-container {
      width: 100%;
    }
    .custom-datepicker-input {
      width: 100%;
      padding: 12px 40px 12px 16px;
      border-radius: 9999px;
      border: 1px solid;
      outline: none;
      font-size: 14px;
      color: #4B5563;
    }
    .custom-datepicker-input.readonly {
      background-color: #f9fafb;
      border-color: #d1d5db;
      cursor: not-allowed;
    }
    .custom-datepicker-input.editable {
      background-color: #ffffff;
      border-color: #60a5fa;
    }
    .custom-datepicker-input.editable.error {
      border-color: #f87171;
    }
    .custom-datepicker-input:focus {
      outline: none;
    }
    .custom-datepicker-input::placeholder {
      color: #9ca3af;
    }
    .react-datepicker__header {
      background-color: #3b82f6;
      border-bottom: 1px solid #3b82f6;
    }
    .react-datepicker__current-month,
    .react-datepicker__day-name {
      color: white;
    }
    .react-datepicker__day:hover {
      background-color: #3b82f6;
    }
    .react-datepicker__day--selected {
      background-color: #3b82f6;
    }
  `;

  useEffect(() => {
    // Add styles
    if (typeof document !== 'undefined' && document.head) {
      const styleElement = document.createElement("style");
      styleElement.textContent = datePickerStyles;
      styleElement.setAttribute('data-component', 'profile-datepicker');

      const existingStyle = document.head.querySelector('[data-component="profile-datepicker"]');
      if (!existingStyle) {
        document.head.appendChild(styleElement);
      }

      return () => {
        const elementToRemove = document.head.querySelector('[data-component="profile-datepicker"]');
        if (elementToRemove) {
          document.head.removeChild(elementToRemove);
        }
      };
    }
  }, []);

  const customSelectStyles = (isEditing, hasError) => ({
    control: (provided, state) => ({
      ...provided,
      minHeight: '48px',
      height: '48px',
      borderRadius: '24px',
      border: isEditing
        ? hasError
          ? '1px solid #f87171'
          : '1px solid #60a5fa'
        : '1px solid #d1d5db',
      backgroundColor: isEditing ? '#ffffff' : '#f9fafb',
      boxShadow: 'none',
      paddingLeft: '12px',
      paddingRight: '12px',
      fontSize: '14px',
      '&:hover': {
        border: isEditing
          ? hasError
            ? '1px solid #f87171'
            : '1px solid #60a5fa'
          : '1px solid #d1d5db',
      }
    }),
    valueContainer: (provided) => ({
      ...provided,
      height: '48px',
      padding: '0 8px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0px',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      height: '48px',
    }),
    placeholder: (provided) => ({
      ...provided,
      color: '#9ca3af',
      fontSize: '14px',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#4b5563',
      fontSize: '14px',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#3b82f6'
        : state.isFocused
          ? '#e0f2fe'
          : 'white',
      color: state.isSelected ? 'white' : '#374151',
      fontSize: '14px',
      '&:hover': {
        backgroundColor: state.isSelected ? '#3b82f6' : '#e0f2fe',
      }
    })
  });

  const validationSchema = Yup.object({
    firstName: Yup.string()
      .min(2, 'First name must be at least 2 characters')
      .max(50, 'First name must be less than 50 characters')
      .required('First name is required'),
    lastName: Yup.string()
      .min(2, 'Last name must be at least 2 characters')
      .max(50, 'Last name must be less than 50 characters')
      .required('Last name is required'),
    displayName: Yup.string()
      .min(3, 'Display name must be at least 3 characters')
      .max(30, 'Display name must be less than 30 characters')
      .required('Display name is required'),
    mobile: Yup.string()
      .required("Please enter phone number")
      .test("is-valid-phone", "Please enter a valid phone number", function (value) {
        if (!value) return false;
        try {
          const phoneNumber = parsePhoneNumberFromString(`+${value}`);
          return phoneNumber && phoneNumber.isValid();
        } catch (error) {
          return false;
        }
      }),
    dateOfBirth: Yup.date()
      .max(new Date(Date.now() - 18 * 365 * 24 * 60 * 60 * 1000), 'You must be at least 18 years old')
      .required('Date of birth is required'),
    addressLine1: Yup.string()
      .min(5, 'Address must be at least 5 characters')
      .max(100, 'Address must be less than 100 characters')
      .required('Address line 1 is required'),
    addressLine2: Yup.string()
      .max(100, 'Address line 2 must be less than 100 characters'),
    townCity: Yup.string()
      .min(2, 'Town/City must be at least 2 characters')
      .max(50, 'Town/City must be less than 50 characters')
      .required('Town/City is required'),
    regionStateProvince: Yup.string()
      .min(2, 'Region/State/Province must be at least 2 characters')
      .max(50, 'Region/State/Province must be less than 50 characters')
      .required('Region/State/Province is required'),
    country: Yup.string()
      .required('Country is required'),
    nationality: Yup.string()
      .required('Nationality is required'),
  });

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      displayName: '',
      mobile: '',
      email: '',
      dateOfBirth: '',
      addressLine1: '',
      addressLine2: '',
      townCity: '',
      regionStateProvince: '',
      country: '',
      nationality: '',
      interested_games: [],
      interested_leagues: []
    },
    validationSchema: isEditingGames ? null : validationSchema,
    onSubmit: async (values) => {
      await updateUserProfile(values);
    },
  });

  const selectedBorderStyle = {
    border: '2.5px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(135deg, #3B82F6, #22C55E)',
    backgroundOrigin: 'border-box',
    backgroundClip: 'padding-box, border-box',
    boxShadow: '0 2px 8px rgba(34,197,94,0.1), 0 1px 4px rgba(59,130,246,0.1)'
  };
  const unselectedBorderStyle = {
    border: '2px solid #D1D5DB',
    boxShadow: '0 1px 4px rgba(0,0,0,0.04)'
  };

  const handleGameToggle = (id) => {
    const alreadySelected = userData.interested_games.includes(id);
    const updatedGames = alreadySelected
      ? userData.interested_games.filter(gid => gid !== id)
      : [...userData.interested_games, id];


    let updatedLeagues = userData.interested_leagues;
    if (alreadySelected) {
      updatedLeagues = userData.interested_leagues.filter(leagueId => {
        const league = preferredLeagues.find(l => l.id === leagueId);
        return league && league.game !== id;
      });
    }

    setUserData(prev => ({
      ...prev,
      interested_games: updatedGames,
      interested_leagues: updatedLeagues
    }));

    formik.setFieldValue('interested_games', updatedGames);
    formik.setFieldValue('interested_leagues', updatedLeagues);

    getLeaguesBasedOnGames(updatedGames);
  };


  const handleLeagueToggle = (id) => {
    const alreadySelected = userData.interested_leagues.includes(id);
    const updatedLeagues = alreadySelected
      ? userData.interested_leagues.filter(lid => lid !== id)
      : [...userData.interested_leagues, id];

    setUserData(prev => ({ ...prev, interested_leagues: updatedLeagues }));
    formik.setFieldValue('interested_leagues', updatedLeagues);
  };

  const getLeaguesBasedOnGames = async (gameIds) => {
    try {
      const searchParams = new URLSearchParams();
      searchParams.append('status', 'active');
      if (gameIds?.length > 0) {
        searchParams.append('game_ids', gameIds.join(','));
      }

      const response = await axios.get(`${baseURL}/pot/preferredleagues/?${searchParams?.toString()}`);
      if (gameIds?.length > 0) {
        setPreferredLeagues(response?.data || []);
      } else {
        setPreferredLeagues([]);
      }
    } catch (error) {
      setPreferredLeagues([]);
    }
  };

  // Helper function to get selected option for react-select
  const getSelectedOption = (options, value) => {
    return options.find(option => option.value === value) || null;
  };

  useEffect(() => {
    (async () => {
      try {
        const { data } = await axios.get(`${baseURL}/accounts/user/me`, {
          headers: {
            Authorization: `Bearer ${JSON.parse(token)}`
          }
        });

        const formatted = {
          firstName: data?.first_name || '',
          lastName: data?.last_name || '',
          displayName: data?.username || '',
          mobile: data?.mobile_number || '',
          email: data?.email || '',
          dateOfBirth: data?.date_of_birth || '',
          addressLine1: data?.address_line_1 || '',
          addressLine2: data?.address_line_2 || '',
          townCity: data?.city || '',
          regionStateProvince: data?.state || '',
          country: data?.country || '',
          nationality: data?.nationality || '',
          interested_games: data?.interested_games || [],
          interested_leagues: data?.interested_leagues || [],
          updated_at: data?.updated_at || '',
        };

        if (data?.date_of_birth === "" || data?.date_of_birth === null) {
          showErrorToast("Please update the required fields marked with *");
        }


        setTermsAccepted(data?.updated_at ? true : false);


        setUserData(formatted);
        setOptionalConsent(data?.optional_consent || false);
        setIsEmailConsent(data?.email_consent || false);
        setIsPhoneConsent(data?.phone_consent || false);
        setIsWhatsappConsent(data?.whatsapp_consent || false);
        setIsSmsConsent(data?.sms_consent || false);
        setPlatformNotifications(data?.platform_emails_consent || false);
        setMarketingEmails(data?.marketing_emails_consent || false);
        setBankData(data?.bank_accounts || []);
        setOriginalUserData(formatted);
        setOriginalConsentStates({
          optionalConsent: data?.optional_consent || false,
          isEmailConsent: data?.email_consent || false,
          isPhoneConsent: data?.phone_consent || false,
          isWhatsappConsent: data?.whatsapp_consent || false,
          isSmsConsent: data?.sms_consent || false,
          platformNotifications: data?.platform_emails_consent || false,
          marketingEmails: data?.marketing_emails_consent || false,
        });
        
        formik.setValues(formatted);
        const games = await axios.get(`${baseURL}/pot/games/?status=true`);
        setPreferredGames(games?.data?.data || []);

        if (data?.interested_games?.length > 0) {
          await getLeaguesBasedOnGames(data?.interested_games);
        }

      } catch (error) {
        if (error?.response?.status === 401) {
          refreshTokenV2(dispatch);
        }
      }
    })();
  }, []);
  console.log(optionalConsent, 'TRUE')
  const updateUserProfile = async (values = formik.values) => {
    try {
      const payload = {
        first_name: values.firstName,
        last_name: values.lastName,
        username: values.displayName,
        mobile_number: values.mobile.replace('+', ''),
        email: values.email,
        date_of_birth: values.dateOfBirth,
        address_line_1: values.addressLine1,
        address_line_2: values.addressLine2,
        city: values.townCity,
        state: values.regionStateProvince,
        country: values.country,
        nationality: values.nationality,
        interested_games: values.interested_games,
        interested_leagues: values.interested_games?.length === 0 ? [] : values.interested_leagues,
        optional_consent: optionalConsent,
        email_consent: optionalConsent ? isEmailConsent : false,
        sms_consent: optionalConsent ? isSmsConsent : false,
        whatsapp_consent: isWhatsappConsent,
        phone_consent: optionalConsent ? isPhoneConsent : false,
        platform_emails_consent: optionalConsent && isEmailConsent ? platformNotifications : false,
        marketing_emails_consent: optionalConsent && isEmailConsent ? marketingEmails : false,
      };

      const response = await axios.put(`${baseURL}/accounts/user/me`, payload, {
        headers: {
          Authorization: `Bearer ${JSON.parse(token)}`,
          'Content-Type': 'application/json',
        }
      });

      showSuccessToast("Profile updated successfully!");
      setOriginalUserData(values);
      setUserData(values);
      setOriginalConsentStates({
        optionalConsent,
        isEmailConsent,
        isPhoneConsent,
        isSmsConsent,
        platformNotifications,
        marketingEmails,
      });
      
      userInfo.userName = values.displayName;
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      setIsEditingProfile(false);
      setIsEditingGames(false);
      setIsEditingLeagues(false);
      return response.data;
    } catch (error) {
      console.error("Update failed:", error?.response?.data?.data?.error);

      // Handle different error scenarios
      if (error.response?.status === 422) {
        const errorData = error.response.data;

        if (errorData?.data?.error) {
          const fieldErrors = errorData.data.error;

          if (fieldErrors.username) {
            showErrorToast(fieldErrors.username[0]);
          } else {
            const firstError = Object.values(fieldErrors)[0];
            showErrorToast(Array.isArray(firstError) ? firstError[0] : firstError);
          }
        } else {
          showErrorToast("Validation error. Please check your input.");
        }
      } else if (error.response?.status === 400) {
        showErrorToast("Bad request. Please check your data.");
      } else if (error.response?.status === 401) {
        refreshTokenV2(dispatch);
        showErrorToast("Unauthorized. Please log in again.");
      } else if (error.response?.status === 500) {
        showErrorToast("Server error. Please try again later.");
      } else {
        showErrorToast("Failed to update profile. Please try again.");
      }
    }
  };


  const handleCancelEdit = () => {
    formik.setValues(originalUserData);
    setTermsAccepted(originalUserData?.updated_at ? true : false);
    setUserData(originalUserData);
    
    // Reset consent states to original values
    setOptionalConsent(originalConsentStates.optionalConsent);
    setIsEmailConsent(originalConsentStates.isEmailConsent);
    setIsPhoneConsent(originalConsentStates.isPhoneConsent);
    setIsWhatsappConsent(originalConsentStates.isWhatsappConsent);
    setIsSmsConsent(originalConsentStates.isSmsConsent);
    setPlatformNotifications(originalConsentStates.platformNotifications);
    setMarketingEmails(originalConsentStates.marketingEmails);
    
    setIsEditingProfile(false);
    if (originalUserData?.interested_games?.length > 0) {
      getLeaguesBasedOnGames(originalUserData.interested_games);
    }
  };

  const handleCancelGamesEdit = () => {
    setIsEditingGames(false);

    setUserData(prev => ({
      ...prev,
      interested_games: originalUserData.interested_games,
      interested_leagues: originalUserData.interested_leagues
    }));

    formik.setFieldValue('interested_games', originalUserData.interested_games);
    formik.setFieldValue('interested_leagues', originalUserData.interested_leagues);

    getLeaguesBasedOnGames(originalUserData?.interested_games);
  };


  const handleCancelLeaguesEdit = () => {
    setUserData(prev => ({ ...prev, interested_leagues: originalUserData.interested_leagues }));
    formik.setFieldValue('interested_leagues', originalUserData.interested_leagues);
    setIsEditingLeagues(false);
  };

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB');
  };


  return (
    <Fragment>
      <Navbar
        setDropdownOpen={setDropdownMenuOpen}
        setSelectedNav={setSelectedNav}
        selectedNav={selectedNav}
        setMobileMenuOpen={setMobileMenuOpen}
        setDropdownPos={setDropdownPos}
        dropdownPos={dropdownPos}
        dropdownOpen={dropdownMenuOpen}
        mobileMenuOpen={mobileMenuOpen}
        setOtherMenusOpen={setOtherMenusOpen}
        otherMenusOpen={otherMenusOpen}
      />

      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            // color: "#1BA56F",
            fontWeight: "700",
            borderRadius: "0px !important",
            border: `1px solid #1BA56F`,
          },
        }}
      />

      <div className="pt-10 md:pt-16 min-h-screen bg-gray-50 bg-[#F6FAFF]">
        <div className="w-[100%] md:w-[98%] mx-auto p-4 py-6 md:py-4 font-sans">
          <div className="p-2">
            <h1 className="text-2xl font-archivo font-semibold text-gray-800 m-0">My Profile</h1>
          </div>

          <form onSubmit={formik.handleSubmit}>
            <section className="bg-white mb-6 p-6 rounded-lg shadow-sm">
              <div className="mb-5">
                <div className="flex justify-between items-center mb-2 md:mb-0">
                  <h2 className="text-sm md:text-lg font-semibold text-gray-800 m-0">Profile Details</h2>
                  {/* Show buttons on desktop */}
                  {isEditingProfile ? (
                    <div className="hidden md:flex gap-2">
                      <button
                        type="submit"
                        disabled={!formik.isValid || !termsAccepted}
                        className="text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-sm font-medium py-1 px-4 rounded-full transition"
                      >
                        Update
                      </button>
                      <button
                        type="button"
                        onClick={handleCancelEdit}
                        className="text-gray-700 border border-gray-300 hover:bg-gray-100 text-sm font-medium py-1 px-4 rounded-full transition"
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    <button
                      type="button"
                      onClick={() => setIsEditingProfile(true)}
                      className="hidden md:flex bg-transparent border-none text-blue-600 cursor-pointer items-center justify-center gap-1 text-sm font-medium py-1 px-2 rounded hover:bg-blue-50 transition-colors duration-200"
                    >
                      Edit <img src={EditIcon} alt="Edit" className="inline pl-1 w-4 h-4" />
                    </button>
                  )}

                  {/* Show edit button on mobile in same line as heading */}
                  {!isEditingProfile && (
                    <button
                      type="button"
                      onClick={() => setIsEditingProfile(true)}
                      className="flex md:hidden bg-transparent border-none text-blue-600 cursor-pointer items-center justify-center gap-1 text-sm font-medium py-1 px-2 rounded hover:bg-blue-50 transition-colors duration-200"
                    >
                      Edit <img src={EditIcon} alt="Edit" className="inline pl-1 w-4 h-4" />
                    </button>
                  )}
                </div>

                {/* Show buttons on mobile below heading when editing */}
                {isEditingProfile && (
                  <div className="flex md:hidden gap-2 mt-3">
                    <button
                      type="submit"
                      disabled={!formik.isValid || !termsAccepted}
                      className="text-white bg-blue-600 hover:bg-blue-700 disabled:bg-gray-400 text-sm font-medium py-2 px-4 rounded-full transition flex-1"
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      onClick={handleCancelEdit}
                      className="text-gray-700 border border-gray-300 hover:bg-gray-100 text-sm font-medium py-2 px-4 rounded-full transition flex-1"
                    >
                      Cancel
                    </button>
                  </div>
                )}
              </div>

              <hr className="mb-6 border-gray-300" />

              {/* Basic Information */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
                {[
                  { field: "firstName", label: "First Name", type: "text" },
                  { field: "lastName", label: "Last Name", type: "text" },
                  { field: "displayName", label: "Display Name", type: "text" }
                ].map((item, index) => (
                  <div key={index} className="flex flex-col">
                    <label className="text-sm text-gray-600 mb-2 font-medium">
                      {item.label} <span className="text-red-500">*</span>
                    </label>
                    <div className="relative">
                      <input
                        type={item.type}
                        name={item.field}
                        value={formik.values[item.field] || ''}
                        readOnly={!isEditingProfile}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        className={`w-full py-3 pr-10 pl-4 border rounded-full text-sm ${isEditingProfile
                          ? formik.touched[item.field] && formik.errors[item.field]
                            ? 'bg-white border-red-400'
                            : 'bg-white border-blue-400'
                          : 'bg-gray-50 border-gray-300'
                          } text-gray-600 focus:outline-none`}
                      />
                      {!isEditingProfile && (
                        <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                      )}
                    </div>
                    {isEditingProfile && formik.touched[item.field] && formik.errors[item.field] && (
                      <span className="text-red-500 text-xs mt-1">{formik.errors[item.field]}</span>
                    )}
                  </div>
                ))}

                {/* Email Field - Always Read Only */}
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">
                    Email <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="email"
                      name="email"
                      value={formik.values.email || ''}
                      readOnly={true}
                      className="w-full py-3 pr-10 pl-4 border rounded-full text-sm bg-gray-50 border-gray-300 text-gray-600 focus:outline-none cursor-not-allowed"
                    />
                    <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                  </div>
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">
                    Mobile Number <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    {isEditingProfile ? (
                      <PhoneInput
                        value={formik.values.mobile || formik.values.phoneNumber}
                        onChange={(phone) => {
                          formik.setFieldValue('mobile', phone);
                        }}
                        onBlur={() => {
                          formik.setFieldTouched('mobile', true);
                        }}
                        masks={{
                          "ae": ".. ... ....",
                        }}
                        enableSearch={true}
                        countryCodeEditable={true}
                        placeholder="Mobile Number*"
                        inputStyle={{
                          width: '100%',
                          borderRadius: '9999px',
                          border: `1px solid ${formik.touched.mobile && formik.errors.mobile
                            ? '#ef4444'
                            : '#60a5fa'
                            }`,
                          fontSize: '14px',
                          paddingLeft: '60px',
                          outline: 'none',
                          height: '48px',
                        }}
                        buttonStyle={{
                          borderRadius: '9999px 0 0 9999px',
                          border: 'none',
                          background: '#f3f4f6',
                          height: '48px',
                          borderRight: '1px solid #d1d5db',
                        }}
                        inputProps={{
                          name: 'mobile',
                          placeholder: 'Mobile Number *',
                          'data-testid': 'mobile',
                          autoComplete: 'tel',
                        }}
                      />
                    ) : (
                      <div className="relative">
                        <div className="w-full py-3 pr-10 pl-4 border rounded-full text-sm bg-gray-50 border-gray-300 text-gray-600">
                          {`+${formik.values.mobile}` || 'Not provided'}
                        </div>
                        <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                      </div>
                    )}
                  </div>
                  {isEditingProfile && formik.touched.mobile && formik.errors.mobile && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.mobile}</span>
                  )}
                </div>
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">
                    Date of Birth <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    {isEditingProfile ? (
                      <DatePicker
                        selected={formik.values.dateOfBirth ? new Date(formik.values.dateOfBirth) : null}
                        onChange={(date) => {
                          if (date) {
                            const formattedDate = date.toISOString().split('T')[0];
                            formik.setFieldValue("dateOfBirth", formattedDate);
                          } else {
                            formik.setFieldValue("dateOfBirth", "");
                          }
                        }}
                        onBlur={() => formik.setFieldTouched("dateOfBirth", true)}
                        placeholderText="Select Date of Birth"
                        dateFormat="dd/MM/yyyy"
                        maxDate={new Date()}
                        showYearDropdown
                        showMonthDropdown
                        dropdownMode="select"
                        className={`custom-datepicker-input editable ${formik.touched.dateOfBirth && formik.errors.dateOfBirth ? "error" : ""
                          }`}
                        autoComplete="off"
                      />
                    ) : (
                      <div className="relative">
                        <div className="w-full py-3 pr-10 pl-4 border rounded-full text-sm bg-gray-50 border-gray-300 text-gray-600">
                          {formatDate(formik.values.dateOfBirth) || 'Not selected'}
                        </div>
                        <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                      </div>
                    )}
                  </div>
                  {isEditingProfile && formik.touched.dateOfBirth && formik.errors.dateOfBirth && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.dateOfBirth}</span>
                  )}
                </div>
              </div>


              {/* Address Information */}
              <h3 className="text-md font-semibold text-gray-800 mb-4">Address Information</h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">
                    Address Line 1 <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="addressLine1"
                      value={formik.values.addressLine1 || ''}
                      readOnly={!isEditingProfile}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`w-full py-3 pr-10 pl-4 border rounded-full text-sm ${isEditingProfile
                        ? formik.touched.addressLine1 && formik.errors.addressLine1
                          ? 'bg-white border-red-400'
                          : 'bg-white border-blue-400'
                        : 'bg-gray-50 border-gray-300'
                        } text-gray-600 focus:outline-none`}
                    />
                    {!isEditingProfile && (
                      <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                    )}
                  </div>
                  {isEditingProfile && formik.touched.addressLine1 && formik.errors.addressLine1 && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.addressLine1}</span>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">Address Line 2</label>
                  <div className="relative">
                    <input
                      type="text"
                      name="addressLine2"
                      value={formik.values.addressLine2 || ''}
                      readOnly={!isEditingProfile}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`w-full py-3 pr-10 pl-4 border rounded-full text-sm ${isEditingProfile ? 'bg-white border-blue-400' : 'bg-gray-50 border-gray-300'
                        } text-gray-600 focus:outline-none`}
                    />
                    {!isEditingProfile && (
                      <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                    )}
                  </div>
                  {isEditingProfile && formik.touched.addressLine2 && formik.errors.addressLine2 && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.addressLine2}</span>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">
                    Town / City <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="townCity"
                      value={formik.values.townCity || ''}
                      readOnly={!isEditingProfile}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`w-full py-3 pr-10 pl-4 border rounded-full text-sm ${isEditingProfile
                        ? formik.touched.townCity && formik.errors.townCity
                          ? 'bg-white border-red-400'
                          : 'bg-white border-blue-400'
                        : 'bg-gray-50 border-gray-300'
                        } text-gray-600 focus:outline-none`}
                    />
                    {!isEditingProfile && (
                      <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                    )}
                  </div>
                  {isEditingProfile && formik.touched.townCity && formik.errors.townCity && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.townCity}</span>
                  )}
                </div>

                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">
                    Region / State / Province <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="regionStateProvince"
                      value={formik.values.regionStateProvince || ''}
                      readOnly={!isEditingProfile}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      className={`w-full py-3 pr-10 pl-4 border rounded-full text-sm ${isEditingProfile
                        ? formik.touched.regionStateProvince && formik.errors.regionStateProvince
                          ? 'bg-white border-red-400'
                          : 'bg-white border-blue-400'
                        : 'bg-gray-50 border-gray-300'
                        } text-gray-600 focus:outline-none`}
                    />
                    {!isEditingProfile && (
                      <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                    )}
                  </div>
                  {isEditingProfile && formik.touched.regionStateProvince && formik.errors.regionStateProvince && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.regionStateProvince}</span>
                  )}
                </div>

                {/* Country Dropdown with react-select */}
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">
                    Country <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    {isEditingProfile ? (
                      <Select
                        name="country"
                        value={getSelectedOption(countryOptions, formik.values.country)}
                        onChange={(selectedOption) => {
                          formik.setFieldValue('country', selectedOption ? selectedOption.value : '');
                        }}
                        onBlur={() => formik.setFieldTouched('country', true)}
                        options={countryOptions}
                        styles={customSelectStyles(isEditingProfile, formik.touched.country && formik.errors.country)}
                        placeholder="Select Country"
                        isClearable
                        isSearchable
                      />
                    ) : (
                      <div className="relative">
                        <div className="w-full py-3 pr-10 pl-4 border rounded-full text-sm bg-gray-50 border-gray-300 text-gray-600">
                          {getSelectedOption(countryOptions, formik.values.country)?.label || 'Not selected'}
                        </div>
                        <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                      </div>
                    )}
                  </div>
                  {isEditingProfile && formik.touched.country && formik.errors.country && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.country}</span>
                  )}
                </div>

                {/* Nationality Dropdown with react-select */}
                <div className="flex flex-col">
                  <label className="text-sm text-gray-600 mb-2 font-medium">
                    Nationality <span className="text-red-500">*</span>
                  </label>
                  <div className="relative">
                    {isEditingProfile ? (
                      <Select
                        name="nationality"
                        value={getSelectedOption(NATIONALITY, formik.values.nationality)}
                        onChange={(selectedOption) => {
                          formik.setFieldValue('nationality', selectedOption ? selectedOption.value : '');
                        }}
                        onBlur={() => formik.setFieldTouched('nationality', true)}
                        options={NATIONALITY}
                        styles={customSelectStyles(isEditingProfile, formik.touched.nationality && formik.errors.nationality)}
                        placeholder="Select Nationality"
                        isClearable
                        isSearchable
                      />
                    ) : (
                      <div className="relative">
                        <div className="w-full py-3 pr-10 pl-4 border rounded-full text-sm bg-gray-50 border-gray-300 text-gray-600">
                          {getSelectedOption(NATIONALITY, formik.values.nationality)?.label || 'Not selected'}
                        </div>
                        <img src={LockIcon} alt="Locked" className="absolute right-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-500" />
                      </div>
                    )}
                  </div>
                  {isEditingProfile && formik.touched.nationality && formik.errors.nationality && (
                    <span className="text-red-500 text-xs mt-1">{formik.errors.nationality}</span>
                  )}
                </div>
              </div>
              <div
                className={`flex items-start gap-2 text-sm text-gray-600 mb-2 mt-4 ${deviceType === "mobile"
                  ? "text-[14px]"
                  : deviceType === "desktop"
                    ? "text-[16px]"
                    : ""
                  }`}
              >
                <input
                  type="checkbox"
                  name="agreeToTerms"
                  id="terms"
                  disabled={!isEditingProfile}
                  checked={termsAccepted}
                  onChange={handleTermsChange}
                  className={`accent-[#0081F8]`}
                  data-testid="terms-checkbox"
                  style={{ verticalAlign: "middle" }}
                />
                <div className="font-inter mt-[-3.5px]">
                  {/* <label htmlFor="terms" className="text-[12px] md:text-[12px] lg:text-[14px]">
                    I confirm that I am 18+ and agree to SportsPik's <a href="/termsAndConditions" className="text-[#0081F8] underline">Terms & Conditions</a> and <a href="/rules" className="text-[#0081F8] underline">Game Rules</a>. 
                    I consent to receive communications including promotions and updates, with the option to opt-out of marketing-related correspondence.
                  </label> */}
                  <label htmlFor="terms" className="text-[12px] md:text-[12px] lg:text-[14px]">
                    I confirm that I am 18+, accept the use of cookies, and agree to SportsPik’s <a href="/termsAndConditions" className="text-[#0081F8] underline">Terms & Conditions and Game Rules.</a>
                  </label>
                </div>
              </div>
              <div
                className={`flex items-start gap-2 text-sm text-gray-600 mb-2 mt-4 ${deviceType === "mobile"
                  ? "text-[14px]"
                  : deviceType === "desktop"
                    ? "text-[16px]"
                    : ""
                  }`}
              >
                <input
                  type="checkbox"
                  name="whatsappConsent"
                  id="whatsappConsent"
                  disabled={!isEditingProfile}
                  checked={isWhatsappConsent}
                  onChange={(e) => setIsWhatsappConsent(e.target.checked)}
                  className={`accent-[#0081F8]`}
                  data-testid="whatsapp-checkbox"
                  style={{ verticalAlign: "middle" }}
                />
                <div className="font-inter mt-[-3.5px]">
                  <label htmlFor="whatsappConsent" className="text-[12px] md:text-[12px] lg:text-[14px]">
                    I would like to receive Whatsapp invite links for game updates and/or Group Discussion Chat.
                  </label>
                </div>
              </div>
              <div
                className={`flex items-start gap-2 text-sm text-gray-600 mb-2 mt-4 ${deviceType === "mobile"
                  ? "text-[14px]"
                  : deviceType === "desktop"
                    ? "text-[16px]"
                    : ""
                  }`}
              >
                <input
                  type="checkbox"
                  name="optionalCheckbox"
                  id="optionalCheckbox"
                  disabled={!isEditingProfile}
                  checked={optionalConsent}
                  onChange={handleOptionalConsentChange}
                  className={`accent-[#0081F8]`}
                  data-testid="optional-checkbox"
                  style={{ verticalAlign: "middle" }}
                />
                <div className="font-inter mt-[-3.5px]">
                  <label htmlFor="optionalCheckbox" className="text-[12px] md:text-[12px] lg:text-[14px]">
                    I consent to receive communications, promotions, and updates from SportsPik and selected third-party partners. I understand I may opt out or update my preferences at any time.
                  </label>
                </div>
              </div>
              <div>
                <h3>
                  Preferred Channels
                </h3>
                <div
                  className={`flex items-start gap-2 text-sm text-gray-600 mb-2 mt-4 ${deviceType === "mobile"
                    ? "text-[14px]"
                    : deviceType === "desktop"
                      ? "text-[16px]"
                      : ""
                    }`}
                >
                  <input
                    type="checkbox"
                    name="isemailconsent"
                    id="isemailconsent"
                    disabled={!isEditingProfile || !optionalConsent}
                    checked={isEmailConsent}
                    onChange={handleEmailConsentChange}
                    className={`accent-[#0081F8]`}
                    data-testid="email-consent"
                    style={{ verticalAlign: "middle" }}
                  />
                  <div className="font-inter mt-[-3.5px]">
                    <label htmlFor="isemailconsent" className="text-[12px] md:text-[12px] lg:text-[14px]">
                      Email
                    </label>
                  </div>
                </div>
                <section className='px-4'>
                  <div
                    className={`flex items-start gap-2 text-sm text-gray-600 mb-2 mt-4 ${deviceType === "mobile"
                      ? "text-[14px]"
                      : deviceType === "desktop"
                        ? "text-[16px]"
                        : ""
                      }`}
                  >
                    <input
                      type="checkbox"
                      name="platformnotifications"
                      id="platformnotifications"
                      disabled={!isEditingProfile || (!optionalConsent || !isEmailConsent)}
                      checked={platformNotifications}
                      onChange={handlePlatformNotificationsChange}
                      className={`accent-[#0081F8]`}
                      data-testid="platformnotifications-consent"
                      style={{ verticalAlign: "middle" }}
                    />
                    <div className="font-inter mt-[-3.5px]">
                      <label htmlFor="platformnotifications" className="text-[12px] md:text-[12px] lg:text-[14px]">
                        Platform Engagement (game updates, reminders, account activity)
                      </label>
                    </div>
                  </div>
                  <div
                    className={`flex items-start gap-2 text-sm text-gray-600 mb-2 mt-4 ${deviceType === "mobile"
                      ? "text-[14px]"
                      : deviceType === "desktop"
                        ? "text-[16px]"
                        : ""
                      }`}
                  >
                    <input
                      type="checkbox"
                      name="marketingnotifications"
                      id="marketingnotifications"
                      disabled={!isEditingProfile || (!optionalConsent || !isEmailConsent)}
                      checked={marketingEmails}
                      onChange={handleMarketingEmailsChange}
                      className={`accent-[#0081F8]`}
                      data-testid="marketingnotifications-consent"
                      style={{ verticalAlign: "middle" }}
                    />
                    <div className="font-inter mt-[-3.5px]">
                      <label htmlFor="marketingnotifications" className="text-[12px] md:text-[12px] lg:text-[14px]">
                        Promotions & Updates
                      </label>
                    </div>
                  </div>
                </section>
                <div
                  className={`flex items-start gap-2 text-sm text-gray-600 mb-2 mt-4 ${deviceType === "mobile"
                    ? "text-[14px]"
                    : deviceType === "desktop"
                      ? "text-[16px]"
                      : ""
                    }`}
                >
                  <input
                    type="checkbox"
                    name="issmsconsent"
                    id="issmsconsent"
                    disabled={!isEditingProfile || !optionalConsent}
                    checked={isSmsConsent}
                    onChange={(e) => setIsSmsConsent(e.target.checked)}
                    className={`accent-[#0081F8]`}
                    data-testid="sms-consent"
                    style={{ verticalAlign: "middle" }}
                  />
                  <div className="font-inter mt-[-3.5px]">
                    <label htmlFor="issmsconsent" className="text-[12px] md:text-[12px] lg:text-[14px]">
                      SMS
                    </label>
                  </div>
                </div>
                <div
                  className={`flex items-start gap-2 text-sm text-gray-600 mb-2 mt-4 ${deviceType === "mobile"
                    ? "text-[14px]"
                    : deviceType === "desktop"
                      ? "text-[16px]"
                      : ""
                    }`}
                >
                  <input
                    type="checkbox"
                    name="isphoneconsent"
                    id="isphoneconsent"
                    disabled={!isEditingProfile || !optionalConsent}
                    checked={isPhoneConsent}
                    onChange={(e) => setIsPhoneConsent(e.target.checked)}
                    className={`accent-[#0081F8]`}
                    data-testid="phone-consent"
                    style={{ verticalAlign: "middle" }}
                  />
                  <div className="font-inter mt-[-3.5px]">
                    <label htmlFor="isphoneconsent" className="text-[12px] md:text-[12px] lg:text-[14px]">
                      Phone Call
                    </label>
                  </div>
                </div>
              </div>
            </section>


          </form>

          {/* Preferred Games */}
          <section className="bg-white mb-6 p-6 rounded-lg shadow-sm">
            <div className="mb-5">
              <div className="flex justify-between items-center">
                <h2 className="text-sm md:text-lg font-semibold text-gray-800 m-0">
                  Preferred Sports ({userData?.interested_games?.length || 0})
                </h2>
                {/* Show buttons on desktop */}
                {isEditingGames ? (
                  <div className="hidden md:flex gap-2">
                    <button
                      type="button"
                      onClick={() => updateUserProfile()}
                      className="text-white bg-blue-600 hover:bg-blue-700 text-sm font-medium py-1 px-4 rounded-full transition"
                    >
                      Update
                    </button>
                    <button
                      type="button"
                      onClick={handleCancelGamesEdit}
                      className="text-gray-700 border border-gray-300 hover:bg-gray-100 text-sm font-medium py-1 px-4 rounded-full transition"
                    >
                      Cancel
                    </button>
                  </div>
                ) : (
                  <button
                    type="button"
                    onClick={() => setIsEditingGames(true)}
                    className="hidden md:flex bg-transparent border-none text-blue-600 cursor-pointer items-center justify-center gap-1 text-sm font-medium py-1 rounded hover:bg-blue-50 transition-colors duration-200"
                  >
                    Edit <img src={EditIcon} alt="Edit" className="inline pl-1 w-4 h-4" />
                  </button>
                )}

                {/* Show edit button on mobile in same line as heading */}
                {!isEditingGames && (
                  <button
                    type="button"
                    onClick={() => setIsEditingGames(true)}
                    className="flex md:hidden bg-transparent border-none text-blue-600 cursor-pointer items-center justify-center gap-1 text-sm font-medium py-1 px-2 rounded hover:bg-blue-50 transition-colors duration-200"
                  >
                    Edit <img src={EditIcon} alt="Edit" className="inline pl-1 w-4 h-4" />
                  </button>
                )}
              </div>

              {/* Show buttons on mobile below heading when editing */}
              {isEditingGames && (
                <div className="flex md:hidden gap-2 mt-3">
                  <button
                    type="button"
                    onClick={() => updateUserProfile()}
                    className="text-white bg-blue-600 hover:bg-blue-700 text-sm font-medium py-2 px-4 rounded-full transition flex-1"
                  >
                    Update
                  </button>
                  <button
                    type="button"
                    onClick={handleCancelGamesEdit}
                    className="text-gray-700 border border-gray-300 hover:bg-gray-100 text-sm font-medium py-2 px-4 rounded-full transition flex-1"
                  >
                    Cancel
                  </button>
                </div>
              )}
            </div>
            <hr className="mb-6 border-gray-300" />

            <div className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-6 lg:grid-cols-8 gap-4">
              {preferredGames?.map((game) => (
                <div
                  key={game?.id}
                  onClick={() => isEditingGames && handleGameToggle(game.id)}
                  className={`relative flex flex-col items-center py-6 px-4 rounded-lg cursor-pointer transition-all duration-200 bg-white group`}
                  style={userData?.interested_games?.includes(game.id) ? selectedBorderStyle : unselectedBorderStyle}
                >
                  {userData?.interested_games?.includes(game.id) && (
                    <div className="absolute -top-3 -right-3 w-7 h-7 rounded-full bg-[#0081F8] flex items-center justify-center border-2 border-white shadow">
                      <svg className="w-4 h-4 text-white" viewBox="0 0 20 20" fill="none">
                        <path d="M6 10l3 3 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  )}
                  <img src={game?.logo} alt={game?.game_name} className="w-12 h-12 mb-2" />
                  <span className="text-sm font-medium text-gray-800 text-center">{game.game_name}</span>
                </div>
              ))}
            </div>
          </section>

          {/* Preferred Leagues */}
          <section className="bg-white mb-6 p-6 rounded-lg shadow-sm">
            <div className="mb-5">
              <div className="flex justify-between items-center">
                <h2 className="text-sm md:text-lg font-semibold text-gray-800 m-0">
                  Preferred Leagues ({userData?.interested_games?.length > 0 ? userData?.interested_leagues?.length : 0})
                </h2>
              </div>
            </div>
            <hr className="mb-6 border-gray-300" />
            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
              {preferredLeagues?.length > 0 ? preferredLeagues?.map((league) => (
                <div
                  key={league.id}
                  onClick={() => isEditingGames && handleLeagueToggle(league.id)}
                  className={`relative flex items-center justify-center p-4 border-2 rounded-lg cursor-pointer transition-all duration-200 bg-white`}
                  style={userData?.interested_leagues?.includes(league.id) ? selectedBorderStyle : unselectedBorderStyle}
                >
                  {userData?.interested_leagues?.includes(league.id) && (
                    <div className="absolute -top-3 -right-3 w-7 h-7 rounded-full bg-[#0081F8] flex items-center justify-center border-2 border-white shadow">
                      <svg className="w-4 h-4 text-white" viewBox="0 0 20 20" fill="none">
                        <path d="M6 10l3 3 6-6" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  )}
                  <img src={league.logo_url} alt={league.name} className="w-6 h-6 sm:w-8 sm:h-8 mr-3" />
                </div>
              )) : <div className="text-sm text-gray-600">No preferred leagues selected</div>}
            </div>

          </section>

          {/* Bank Details */}
          <section className="mb-6 rounded-lg shadow-sm">
            <div className="mb-6 flex flex-col md:flex-row justify-between md:items-center">
              <h2 className="text-lg md:text-xl font-semibold font-archivo text-gray-800 m-0">Bank Details</h2>
              <p className="mt-2 mb-0 text-sm">We store only the last two bank details</p>
            </div>

            <div className="flex flex-col gap-5">
              {bankData?.length > 0 ? bankData?.map((item, index) => (
                <div key={index} className="border border-gray-200 rounded-lg overflow-hidden bg-white">
                  <div className="flex justify-between items-center py-4 px-5 border-b border-gray-200">
                    <h3 className="m-0 text-base font-semibold text-gray-800">Account - {index + 1}</h3>
                    <img src={LockIcon} alt="Locked" className="w-5 h-5 text-gray-500" />
                  </div>
                  <div className="p-5">
                    <div className="flex flex-col sm:flex-row mb-3 sm:items-start">
                      <span className="text-sm text-gray-600 min-w-[140px] flex-shrink-0 sm:mr-4 mb-1 sm:mb-0">Transfer Type :</span>
                      <span className="text-sm text-gray-800 font-medium">{transferTypeOptions[item?.account_type]}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row mb-3 sm:items-start">
                      <span className="text-sm text-gray-600 min-w-[140px] flex-shrink-0 sm:mr-4 mb-1 sm:mb-0">Account Number :</span>
                      <span className="text-sm text-gray-800 font-medium">{decryptAccountDetails(item?.account_number)}</span>
                    </div>
                    <div className="flex flex-col sm:flex-row sm:items-start">
                      <span className="text-sm text-gray-600 min-w-[140px] flex-shrink-0 sm:mr-4 mb-1 sm:mb-0">Account Name :</span>
                      <span className="text-sm text-gray-800 font-medium">{decryptAccountDetails(item?.account_name)}</span>
                    </div>
                  </div>
                </div>)) : null}
            </div>
          </section>
        </div>
        <>
          <Footer componnent="rules" />
        </>
      </div>
    </Fragment>
  );
};

export default MyProfile;